//
//
//
//
//
//
//
//
//
//
//
//
//

import {EventBus, BUS_EVENT } from '../../eventBus';
import {audio as audioText} from "../../utils/audioText"
  export default {
    name: "TypeFlowMessage",
    components: {
      
    },
    props: {
        stringText:String, //显示聊天内容
        speed:Number, //显示速度 毫秒/字
        playState:Boolean,//播放文本按钮状态
        itemID:String,
        msgQueue:Array,
    },
    data() {
      return {
        displayMessage:"",
        totalMessage:this.stringText || "",
        intervalHandler:undefined,
        displayIndex:0,
        disSpeed:200,
        playTextVoiceSatate:this.playState,
        questionList:[]
      };
    }, 
    mounted() {
        
    },
    created(){
      this.init()
      this.addQAState=false //正在添加qa
      this.curQaIndex=0;//qa添加索引
      this.tempChar=''

    },
    beforeDestroy() {}, 
    methods: {
      onAsk(question){
        this.$emit('onClickQuestion',question)
      },
      /**
       * 处理下一帧文字
       * 返回： true:所有消息结束 false:消息未结束
       */
      nextAudio(){
        if(this.audioRead>=this.msgQueue.length){
          return
        }
        if(!this.msgQueue[this.audioRead].audioState || this.msgQueue[this.audioRead].audioState==0){ //0-还未开始 1-播放中 2-播放结束
      
          if(this.msgQueue[this.audioRead].audio){
            
            if(audioText){
              audioText.pause()
              audioText.autoplay=false
              audioText.src=this.msgQueue[this.audioRead].audio
              audioText.muted=false
              
              audioText.play().then(()=>{

              },err=>{
                //  alert(err)
                console.error(err)
              })
              this.msgQueue[this.audioRead].audioState=1
              console.log('开始播放语音:',this.msgQueue[this.audioRead].audio)
            }
          }
          else{
            this.msgQueue[this.audioRead].audioState=2
            this.audioRead++
            this.nextAudio()
          }
        
      }
      },  
      nextMessage(){
        if(this.msgQueue.length==0){
          return false
        }
        
        if(this.ptrRead.index<this.msgQueue.length){
          if(this.msgQueue[this.ptrRead.index].flag=='start'){
            this.ptrRead.index = this.ptrRead.index+1
            this.ptrRead.subIndex=0
            EventBus.$emit(BUS_EVENT.ENABLE_INPUT,{enable:false})
          }
          else if(this.msgQueue[this.ptrRead.index].flag=='ing'){
            if(this.ptrRead.subIndex<this.msgQueue[this.ptrRead.index].txt.length){
                let txt = this.msgQueue[this.ptrRead.index].txt
                if(this.addQAState==false && txt[this.ptrRead.subIndex]=='<'
                 && txt[this.ptrRead.subIndex+1]  == 'a' 
                 && txt[this.ptrRead.subIndex+2]=='>') //匹配到开头
                {
                  this.addQAState = true
                  this.ptrRead.subIndex+=2
                }
                else if(this.addQAState){
                  
                  if(txt[this.ptrRead.subIndex]=='<' && txt[this.ptrRead.subIndex+1] == '/'
                    && txt[this.ptrRead.subIndex+2]=='a' && txt[this.ptrRead.subIndex+3]=='>'){ //匹配到结尾
                      this.curQaIndex++
                      this.addQAState=false
                      this.ptrRead.subIndex+=3
                  }
                  else{
                    if(this.curQaIndex>=this.questionList.length){
                      this.questionList.push(txt[this.ptrRead.subIndex])
                    }
                    else{
                      this.questionList[this.curQaIndex]+=txt[this.ptrRead.subIndex]
                    }
                    this.$forceUpdate()
                    
                  }
                }
                else{
                  this.displayMessage+=this.msgQueue[this.ptrRead.index].txt[this.ptrRead.subIndex]
                }
               
                this.ptrRead.subIndex++
                  
            }
            else{ //跳转下一个
                  this.ptrRead.index = this.ptrRead.index+1
                  this.ptrRead.subIndex=0
                  this.nextMessage()
            }
            
            
          }
          else if(this.msgQueue[this.ptrRead.index].flag=='end'){
                this.ptrRead.index = this.ptrRead.index+1
                this.ptrRead.subIndex=0
          }
  
        }
        else{
            let lastItem =this.msgQueue[this.msgQueue.length-1]
            if(lastItem.flag == 'end'){ //播放结束
                console.log('----------------------end')
               
                return true
            }
        }
        return false
      },
      init(){
        console.log('type init ')
          this.ptrRead={
            index:0,
            subIndex:0
          }
          this.audioRead=0
          if(this.intervalHandler) clearInterval(this.intervalHandler)

          this.displayMessage=""
          this.intervalHandler = setInterval(()=>{
              let isEnd = this.nextMessage()
              // this.nextAudio()
              if(isEnd){
                this.disSpeed=0
                this.totalMessage = this.displayMessage
                clearInterval(this.intervalHandler)
                this.$emit('onTextShowAccomplish',{itemID:this.itemID})
                EventBus.$emit(BUS_EVENT.ENABLE_INPUT,{enable:true})

              }
          },200)
          // audioText.addEventListener('ended',()=>{
          //   console.log('-=-=-=-=-=-= end')
          //   if(this.audioRead<this.msgQueue.length){
          //       this.msgQueue[this.audioRead].audioState = 2 //播放结束，开始下一个 
          //       this.audioRead++
          //       this.nextAudio()
          //       console.log('语音播放结束，播放下一个语音:')
          //   }
                
          // })
      },
      getCurShowLength(){
        return this.displayMessage.length
      },
      //播放文字语音
      onPlayTextVoice()
      {
        
        // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
        this.$emit('onPlayText')
      },
    },
    watch: {
  
      playState(value){
        this.playTextVoiceSatate=value
      },
      stringText(value){
        this.totalMessage=value
      }
    },
    expose:{

    }
  };
  


// WEBPACK FOOTER //
// ./src/myComponents/TypeFlowMessage/TypeFlowMessage.vue